import * as React from 'react';
import s from './pagination.scss';
import {generatePath} from '../../utils/pagination';
import {validatePath} from '../../utils';
import Desktop from '../partials/pagination/Desktop';
import Mobile from '../partials/pagination/Mobile';
import {History} from 'history';
import {Experiment} from '../../reducers/experiments';

export interface PaginationProps {
  data: any;
  history: History;
  loadArticles: (...args: any[]) => any;
  experiments?: Experiment[];
}

class Pagination extends React.Component<PaginationProps, {}> {
  makePagePath(page) {
    const {location} = this.props.history;
    const path = validatePath(location.pathname);
    const search = location.search;
    return generatePath(path, page, search);
  }
  render() {
    const {data, experiments = []} = this.props;
    const {range} = data;
    if (range.length <= 1) {
      return <span data-hooks="pagination-navigation" />;
    }
    return (
      <div className={s.navigation}>
        <div className={s.desktopMode}>
          <Desktop
            data={this.props.data}
            makePagePath={page => this.makePagePath(page)}
          />
        </div>
        <div className={s.mobileMode}>
          <Mobile
            data={this.props.data}
            experiments={experiments}
            makePagePath={page => this.makePagePath(page)}
          />
        </div>
      </div>
    );
  }
}
export default Pagination;
